import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Api} from '../utils';
import {RequestsHandler} from './requests.service';
import {Observable} from "rxjs/Rx";


@Injectable()
export class PaymentService {
  constructor(private http: HttpClient,
              private api: Api,
              private handler: RequestsHandler
  ) {}

  payerFail(ref) {
    return this.http.get(this.api.getUrl(`payment/payer-fail/${ref}`), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/payment.service.ts